import React, { useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import { MaterialReactTable } from "material-react-table";
import { Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import TitlePages from "../../../layout/TitlePages";
import Breadcrumbs from "../../../layout/Breadcrumbs";
import Expandible from "../../../layout/HelperDataTable/Expandible";
import { useCompleteTableConfig } from "../../../constants";
import { dataAcuerdosINE2025 } from "../../../data/2025/dataAcuerdos";
import {
  AcuerdosDetailContainer,
  AcuerdosDetailSection,
  AcuerdosDetailRow,
} from "../../../components/acuerdos/AcuerdosDetail";

const baseUrl = "https://itetlax.org.mx/assets/pdf/acuerdos/INE/2025";

const FileLink = ({ baseUrl, url, type }) => {
  const icon = type === "pdf" ? faFilePdf : faFileExcel;
  const className = type === "pdf" ? "btn btn-danger" : "btn btn-success";
  const fullUrl = `${baseUrl}/${url}`;

  return (
    <a className="link" href={fullUrl} target="_blank" rel="noreferrer">
      <FontAwesomeIcon icon={icon} className={className} />
    </a>
  );
};

const TableRow = ({ title, url, type }) => {
  return title && url ? (
    <tr>
      <td>{title.toUpperCase()}</td>
      <td>
        <FileLink baseUrl={baseUrl} url={url} type={type} />
      </td>
    </tr>
  ) : null;
};

const AcuerdosINE2025 = () => {
  useEffect(() => {
    document.title = `Acuerdos INE 2025`;
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "numDoc",
        header: "DOCUMENTO",
        footer: "DOCUMENTO",
      },
      {
        accessorKey: "nameDoc",
        header: "DESCRIPCIÓN",
        footer: "DESCRIPCIÓN",
        muiTableBodyCellProps: {
          sx: {
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: "none",
            width: "auto",
          },
        },
      },
    ],
    []
  );
  const renderDetailPanelAcuerdos = ({ row }) => {
    const anexoRows = [];
    for (let i = 1; i <= 70; i++) {
      const titlePDF = row.original[`titleAnexoPDF${i}`];
      const titleExcel = row.original[`titleAnexoEXCEL${i}`];
      if (titlePDF) {
        anexoRows.push({
          key: `pdf-${i}`,
          title: titlePDF.toUpperCase(),
          url: `${baseUrl}/${row.original.id}.${i}.pdf`,
          type: "pdf",
        });
      }
      if (titleExcel) {
        anexoRows.push({
          key: `excel-${i}`,
          title: titleExcel.toUpperCase(),
          url: `${baseUrl}/${row.original.id}.${i}.xlsx`,
          type: "excel",
        });
      }
    }

    return (
      <AcuerdosDetailContainer>
        <AcuerdosDetailSection title="ACUERDO">
          <AcuerdosDetailRow
            title={`${row.original.numDoc} ${row.original.nameDoc || ""}`.trim()}
            url={`${baseUrl}/${row.original.id}.pdf`}
            isMain={true}
          />
        </AcuerdosDetailSection>

        {anexoRows.length > 0 && (
          <AcuerdosDetailSection title="ANEXO">
            {anexoRows.map((item) => (
              <AcuerdosDetailRow
                key={item.key}
                title={item.title}
                url={item.url}
                type={item.type}
              />
            ))}
          </AcuerdosDetailSection>
        )}
      </AcuerdosDetailContainer>
    );
  };
  
  const tableAcuerdos = useCompleteTableConfig(
    dataAcuerdosINE2025,
    columns,
    renderDetailPanelAcuerdos
  );

  return (
    <>
      <div className="margin-bottom-2">
        <Breadcrumbs
          path={[
            { label: "Acuerdos INE", url: "/AcuerdosINE" },
            { label: "Acuerdos INE 2025" },
          ]}
        />
        <TitlePages title="Acuerdos INE" subTitle="Acuerdos INE 2025" />
        <Expandible />
        <MaterialReactTable table={tableAcuerdos} />
      </div>
    </>
  );
};

export default AcuerdosINE2025;

FileLink.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["pdf", "excel"]).isRequired,
};

TableRow.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["pdf", "excel"]).isRequired,
};
